export enum CloudGatewayDiscoveryStatus {
	InProgress = 'IN_PROGRESS',
	Complete = 'DISCOVERY_COMPLETE',
	DeviceBusy = 'DEVICE_BUSY',
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	DeviceUnavailable = 'DEVICE_UNAVAILABLE',
	Failure = 'FAILURE'
}
